import { supabase } from '@/lib/supabase';
import { BlogPost } from '@/types/types';

export const blogService = {
  /**
   * Fetch all blog posts
   */
  getAllPosts: async (): Promise<BlogPost[]> => {
    try {
      const { data, error } = await supabase
        .from('blog')
        .select('*')
        .order('date', { ascending: false });
      
      if (error) throw error;
      return data as BlogPost[];
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  },

  /**
   * Fetch recent blog posts (most recent n posts)
   */
  getRecentPosts: async (count: number = 3): Promise<BlogPost[]> => {
    try {
      const { data, error } = await supabase
        .from('blog')
        .select('*')
        .order('date', { ascending: false })
        .limit(count);
      
      if (error) throw error;
      return data as BlogPost[];
    } catch (error) {
      console.error('Error fetching recent blog posts:', error);
      throw error;
    }
  },

  /**
   * Fetch a single blog post by slug
   */
  getPostBySlug: async (slug: string): Promise<BlogPost | null> => {
    try {
      const { data, error } = await supabase
        .from('blog')
        .select('*')
        .eq('slug', slug)
        .single();
      
      if (error) throw error;
      return data as BlogPost;
    } catch (error) {
      console.error(`Error fetching blog post with slug ${slug}:`, error);
      throw error;
    }
  }
};